import { type ReactNode } from 'react'
import { Layout } from 'antd'
import { AppHeader } from './AppHeader'

const { Content } = Layout

interface AppLayoutProps {
  children: ReactNode
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <Layout style={{ minHeight: '100vh', backgroundColor: '#f0f2f5' }}>
      <AppHeader />
      <Layout style={{ backgroundColor: '#f0f2f5' }}>
        <Content
          style={{
            padding: '24px 24px',
            margin: 0,
            minHeight: 'calc(100vh - 64px)',
            maxWidth: '100%'
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  )
}
